import { lazy } from "react";
import { SETTINGS } from "pages/routes/route.constant";
const settings = lazy(() => import("pages/Settings"));

export default {
  path: SETTINGS,
  element: settings,
};
